import http, {makeSearchParams} from 'utils/http';

// watchlist group
export const getWatchList = (data, watchlistId = 0) => {
  return http('GET', `/watchlist/${watchlistId}/items`, makeSearchParams(data));
};

export const getWatchListByCert = (certId, data, watchlistId = 0) => {
  return http(
    'GET',
    `/watchlist/${watchlistId}/items/${certId}`,
    makeSearchParams(data)
  );
};

// reused
export const addWatchList = (data, wlId = 0) => {
  return http('POST', `se/company-list/items/add-to-watchlist/${wlId}`, data);
};

// reused
export const deleteWatchList = (data, wlId = 0) => {
  return http(
    'DELETE',
    `se/company-list/items/remove-from-watchlist/${wlId}`,
    data
  );
};

// accumulated watchlist
export const getWatchlistItems = (queries) => {
  return http('GET', `/watchlist/items`, makeSearchParams(queries));
};

export const deleteWatchlistItems = () => {
  return http('DELETE', `/watchlist/items`);
};

export const deleteWatchlistWliItems = (wliId = 0, data) => {
  return http('DELETE', `/watchlist/${wliId}`, data);
};

// tags
export const putWatchlistItemsWlId = (wliId = 0, data) => {
  return http('PUT', `/watchlist/items/${wliId}`, data);
};

// filters
export const getWatchlistItemsStandards = (data, wliId = 0) => {
  return http('GET', `watchlist/${wliId}/items/standards`, data);
};

export const getFilterTags = (data) => {
  return http('GET', 'tags', makeSearchParams(data));
};
